import { render } from "./HeadToolBar.vue?vue&type=template&id=3454f31a&ts=true"
import script from "./HeadToolBar.vue?vue&type=script&lang=ts"
export * from "./HeadToolBar.vue?vue&type=script&lang=ts"

import "./HeadToolBar.vue?vue&type=style&index=0&id=3454f31a&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__